import { getProfile, signIn, signInCoach } from "../../api/auth.api";
import {
  loginPending,
  loginSuccess,
  loginFailed,
  logoutUserSuccess,
  ACCESS_TOKEN_KEY,
} from "./reducer";
import { AppDispatch } from "../../../../store";
import { toast } from "react-toastify";

export const fetchProfile = () => async (dispatch: AppDispatch) => {
  const token = localStorage.getItem(ACCESS_TOKEN_KEY);
  if (!token) return;

  try {
    const response = await getProfile();
    if (response?.success && response?.data) {
      const {
        user,
        permissions,
        role,
        organizations,
        accessToken,
        teams,
        departmentsLeading,
        teamsLeading,
      } = response.data;
      dispatch(
        loginSuccess({
          user,
          accessToken: accessToken ?? token,
          permissions: permissions ?? [],
          role: role ?? [],
          organizations: organizations ?? [],
          teams: teams ?? [],
          departmentsLeading: departmentsLeading ?? [],
          teamsLeading: teamsLeading ?? [],
        }),
      );
    }
  } catch {
    dispatch(logoutUserSuccess());
  }
};

export const loginUser =
  (payload: { email: string; password: string }, navigate: any) =>
  async (dispatch: AppDispatch) => {
    dispatch(loginPending());
    try {
      const response = await signIn(payload);

      if (response.success) {
        const {
          user,
          accessToken,
          permissions,
          role,
          organizations,
          teams,
          departmentsLeading,
          teamsLeading,
        } = response.data;

        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);

        dispatch(
          loginSuccess({
            user,
            accessToken,
            permissions,
            role,
            organizations,
            teams: teams ?? [],
            departmentsLeading: departmentsLeading ?? [],
            teamsLeading: teamsLeading ?? [],
          }),
        );

        toast.success(response.message ?? "Login successful!");
        navigate("/locker-room");
      }
    } catch (err: any) {
      const message = err.response?.data?.message ?? "Login failed!";
      dispatch(loginFailed({ message }));
      toast.error(message);
    }
  };

export const loginCoach =
  (payload: { email: string; password: string }, navigate: any) =>
  async (dispatch: AppDispatch) => {
    dispatch(loginPending());
    try {
      const response = await signInCoach(payload);

      if (response.success) {
        const { user, accessToken, permissions, role, organizations } =
          response.data;

        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);

        dispatch(
          loginSuccess({
            user,
            accessToken,
            permissions,
            role,
            organizations,
          }),
        );

        toast.success(response.message ?? "Login successful!");
        navigate("/locker-room");
      }
    } catch (err: any) {
      const message = err.response?.data?.message ?? "Login failed!";
      dispatch(loginFailed({ message }));
      toast.error(message);
    }
  };

export const logoutUser = (navigate?: any) => async (dispatch: AppDispatch) => {
  try {
    localStorage.clear();
    dispatch(logoutUserSuccess());
    toast.success("Logged out successfully!");
    if (navigate) navigate("/login");
  } catch {
    toast.error("Logout failed!");
  }
};
